import { create } from "zustand";

type CalculationOverviewDialogState = {
  isOpen: boolean;
  initialServiceId: number | null;
  initialOrganizationId: string | null;
};

type CalculationOverviewDialogActions = {
  /**
   * Open the calculation overview dialog.
   * If a serviceId is provided, the dialog will auto-select that service.
   */
  openDialog: (_serviceId?: number | null, _organizationId?: string | null) => void;
  /**
   * Close the dialog and reset any stored initialServiceId so it doesn't "stick"
   * the next time the dialog is opened from the header.
   */
  closeDialog: () => void;
  /** Set the service id without opening the dialog (rare; mostly for internal use). */
  setInitialServiceId: (_serviceId: number | null) => void;
  /** Set the organization id without opening the dialog (rare; mostly for internal use). */
  setInitialOrganizationId: (_organizationId: string | null) => void;
};

const initialState: CalculationOverviewDialogState = {
  isOpen: false,
  initialServiceId: null,
  initialOrganizationId: null,
};

export const useCalculationOverviewDialogStore = create<CalculationOverviewDialogState & CalculationOverviewDialogActions>((set) => ({
  ...initialState,
  openDialog: (serviceId, organizationId) =>
    set({
      isOpen: true,
      initialServiceId: serviceId ?? null,
      initialOrganizationId: organizationId ?? null,
    }),
  closeDialog: () => set({ ...initialState }),
  setInitialServiceId: (serviceId) => set({ initialServiceId: serviceId }),
  setInitialOrganizationId: (organizationId) => set({ initialOrganizationId: organizationId }),
}));

export function openCalculationOverviewDialog(serviceId?: number | null, organizationId?: string | null) {
  useCalculationOverviewDialogStore.getState().openDialog(serviceId, organizationId);
}

export function closeCalculationOverviewDialog() {
  useCalculationOverviewDialogStore.getState().closeDialog();
}
